import {Component, OnInit} from '@angular/core';
import {Params, ActivatedRoute, Router} from "@angular/router";
import {LoaderService} from "../../../services/loader.service";
import {AlertService} from "../../../services/alert.service";
import {CashBookingService} from "../../../services/cash-booking.service";
import {PrintService} from "../../../services/print.service";
import {SettingsService} from "../../../services/settings.service";
import {AccountBookingService} from "../../../services/account-booking.service";

@Component({
  selector: 'app-cash-booking-print',
  templateUrl: './cash-booking-print.component.html',
  styleUrls: ['./cash-booking-print.component.css']
})

export class CashBookingPrintComponent implements OnInit {
  id;
  cashBookFormObject = {};
  showGSTIN = false;
  firmData = {};
  pageSize = 'A4';
  type;

  constructor(private cashBookingService:CashBookingService,
              private accountBookingService:AccountBookingService,
              private alertService:AlertService,
              private printService:PrintService,
              private settingsService:SettingsService,
              private loaderService:LoaderService,
              private route:ActivatedRoute,
              private router:Router) {
  }

  ngOnInit() {
    this.route.queryParams.forEach((params:Params) => {
      this.id = params['id'];
      this.type = params['type'];
    });
    this.id ? this.loaderService.loading(true) : null;
    this.id ? this.type == 'cashBooking' ? this.cashBookingService.getById(this.id).subscribe(
      data => {
        this.cashBookFormObject = data[0] || {};
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      }) : this.accountBookingService.getById(this.id).subscribe(
      data => {
        this.cashBookFormObject = data[0] || {};
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      }) : this.router.navigate(['/cash_booking_list']);
    this.getFirmData();
  }

  setPageSize($event) {
    this.pageSize = $event.target.value == 'A4' ? 'A4' : 'col-xs-6';
  }

  getFirmData() {
    this.loaderService.loading(true);
    this.settingsService.firmDetails().subscribe(
      data => {
        data.length ? this.firmData = data[0] : null;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  displayGSTIN($event) {
    this.showGSTIN = $event.target.checked;
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/cash-book/cash-booking-print/cash-booking-print.component.ts